"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBrowserFontSizeFactor = exports.getBrowserFontSizeFactor = void 0;
var hooks_1 = require("evt/hooks");
var evt_1 = require("evt");
var memoizee_1 = __importDefault(require("memoizee"));
exports.getBrowserFontSizeFactor = memoizee_1.default(function () {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var rootElement = document.querySelector("html");
    var fontSize = rootElement.style.fontSize;
    rootElement.style.fontSize = "100%";
    var browserFontSizeFactor = parseInt(window.getComputedStyle(rootElement, null)
        .getPropertyValue("font-size")
        .replace(/px$/, "")) / 16;
    rootElement.style.fontSize = fontSize;
    return browserFontSizeFactor;
});
function useBrowserFontSizeFactor() {
    var evtBrowserFontSizeFactor = hooks_1.useEvt(function (ctx) {
        return evt_1.Evt.from(ctx, window, "focus")
            .toStateful()
            .pipe(function () {
            exports.getBrowserFontSizeFactor.clear();
            return [exports.getBrowserFontSizeFactor()];
        });
    }, []);
    hooks_1.useRerenderOnStateChange(evtBrowserFontSizeFactor);
    return { "browserFontSizeFactor": evtBrowserFontSizeFactor.state };
}
exports.useBrowserFontSizeFactor = useBrowserFontSizeFactor;
//# sourceMappingURL=useBrowserFontSizeFactor.js.map